// CONSTANTS are all caps.
const NS = 'SiteHeader';
const CLS = 'siteHeader';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import * as utils from '../../../../global/js/utils';
import {searchByBrand} from './searchByBrand';
import {splitEmailEgiftCard} from '../../../../global/js/cart';

export class SiteHeader {
	constructor($el) {
		// $el is the blk node return by the loadSiteHeader function
		this.$el = $el;
		this.mouseTimer = null;
	}

	init() {
		this.setSiteHeader();
		this.setStickyHeader();
		this.newMenuMobile();
		this.handleLogoutCDC();
	}

	setSiteHeader() {
		// Add Some logic here
		let navItem = $('.siteHeader .nav-item');

		if (!utils.isOnMobile()) {
			this.toggleSiteNavItemsOnHover();
		}

		// this.toggleSearch();
		this.onResize();

		// stop the dropdown from toggling the hover state
		navItem.on('click', function(e) {
			if (!utils.isOnMobile()) {
				e.stopPropagation();
			}
		});
		// menu mobile "Accordion"
		this.menuMobileAccordion();

		$('.siteHeader-link[href="/Logout"]').on('click', () => {
			if (window.localStorage) {
				window.localStorage.removeItem(`bris.findInStore.value`);
			}
		});
	}

	newMenuMobile() {
		if ($('.siteHeader').hasClass('mobile-menu-2022')) {
			let $navbarToggle = $('.navbar-toggler');
			let $container = $('.slidingMenuMobile-container');
			let $mobileAccount = $('.mobile-account-expand');
			let $body = $('body');
			const resizeImg = function() {
				$('.mobile-banner img').each(function(index, el) {
					let $el = $(el);
					let widthImg = $el.width();
					let heightImg = $el.height();
					let ratio = widthImg / heightImg;
					// for case width > height but not enough width to full container (ex 400x300)
					let ratioBanner = 2.375;
					if (widthImg > heightImg) {
						if (ratio > ratioBanner || $el.closest('.mobile-banner').hasClass('col-type')) {
							$el.addClass('img-wide');
						}
					}
				});
			};
			if (utils.isOnMobile()) {
				$navbarToggle.on('click', function(e) {
					e.stopPropagation();
					if ($mobileAccount.hasClass('active')) {
						$('.mobile-account-action').trigger('click');
					}
					if (!$navbarToggle.hasClass('active')) {
						$container.scrollTop(0);
					}
					$navbarToggle.toggleClass('active');
					$container.toggleClass('active');
					$body.toggleClass('show-backdrop');
					// After toggle
					if (!$navbarToggle.hasClass('active')) {
						$container.removeClass('open-level-2');
						$container.removeClass('open-level-3');
						$('.level-1 > li.active').removeClass('active');
						$('.level-2 > li.active').removeClass('active');
					}
					resizeImg();
				});

				$('.level-1 > li > .menu-item').on('click', function(e) {
					e.stopPropagation();
					$container.addClass('open-level-2');
					let $li = $(this).closest('li');
					$li.addClass('active');
					$container.animate({scrollTop: 0}, 500, function() {
						if ($li.find('.level-heading.brand').length) {
							let offset = $('#search-by-brand').offset().top;
							searchByBrand('mobile', offset);
						}
					});
					resizeImg();
				});

				$('.level-2 > li > .menu-item').on('click', function(e) {
					e.stopPropagation();
					$container.addClass('open-level-3');
					let $li = $(this).closest('li');
					$li.addClass('active');
					$li.find('.level-3 li').each(function(index, li) {
						if ($(li).find('.menu-item').length) {
							let $level4 = $(li).find('.level-4');
							if ($level4.hasClass('open')) {
								$level4.css('display', 'block');
							} else {
								$level4.css('display', 'none');
							}
						}
					});
					$container.animate({scrollTop: 0}, 500);
					resizeImg();
				});

				$('.level-3 > li > .menu-item').on('click', function(e) {
					e.stopPropagation();
					let $li = $(this).closest('li');
					let $level4 = $li.find('.level-4');
					$li.toggleClass('active');
					$level4.slideToggle(300, function() {
						$(this).toggleClass('open');
					});
					resizeImg();
				});

				$('.go-back a').on('click', function(e) {
					e.stopPropagation();
					if ($container.hasClass('open-level-3')) {
						$container.removeClass('open-level-3');
						$('.level-2 > li.active').removeClass('active');
					} else if ($container.hasClass('open-level-2')) {
						$container.removeClass('open-level-2');
						$('.level-1 > li.active').removeClass('active');
					}
				});

				$('#klevuSearch-input-mobile').focusin(function() {
					if ($navbarToggle.hasClass('active')) {
						$navbarToggle.trigger('click');
					}
				});

				$('#regionStoreSelector-toggle').on('click', function() {
					if ($navbarToggle.hasClass('active')) {
						$navbarToggle.trigger('click');
					}
				});
			}

			// Account
			$('.icon-account').on('click', function() {
				if ($navbarToggle.hasClass('active')) $navbarToggle.trigger('click');
				$mobileAccount.toggleClass('active');
				$body.toggleClass('show-backdrop');
			});
			$('.mobile-account-action').on('click', function() {
				$mobileAccount.removeClass('active');
				$body.removeClass('show-backdrop');
			});
		}
		if ($('.siteHeader').hasClass('desktop-menu-2022')) {
			searchByBrand('desktop');
			let containerHeight = 0;
			const resizeImg = function($parent) {
				$parent.find('.menu-banner-img img').each(function(index, el) {
					let $el = $(el);
					let widthImg = $el.width();
					let heightImg = $el.height();
					let ratio = widthImg / heightImg;
					// ratio each type (1, 2, 3 or 4 images in a row) will difference
					let ratioBanner = 2.375;
					let $menuBanner = $el.closest('.menu-banner');
					if (widthImg > heightImg) {
						if ($menuBanner.hasClass('col-banner-1')) {
							if (ratio > ratioBanner) $el.addClass('img-wide');
						} else if ($el.closest('.menu-group').hasClass('full-width') && $menuBanner.hasClass('col-banner-2')) {
							if (ratio > 2) $el.addClass('img-wide');
						} else if ($menuBanner.hasClass('col-banner-4')) {
							if (($menuBanner.hasClass('two') && ratio > 2) ||
								($menuBanner.hasClass('three') && ratio > 1.53) ||
								($menuBanner.find('.menu-banner-img').length === 4 && ratio > 1)) {
								$el.addClass('img-wide');
							}
						} else {
							$el.addClass('img-wide');
						}
					}
				});
				$parent.addClass('checked-image-size');

				// col-banner-4 with 2 or 3 images
				let colFour = $parent.find('.col-banner-4');
				if (colFour.length) {
					colFour.each(function(index, el) {
						let $col = $(el);
						let imgs = $col.find('.menu-banner-img');
						if (imgs.length === 1 || imgs.length === 2) {
							$col.addClass('two');
						} else if (imgs.length === 3) {
							$col.addClass('three');
						}
					});
				}
			};

			$('.d-level-1 > li').mouseenter(function() {
				let $this = $(this);
				this.mouseTimer = setTimeout(() => {
					$this.addClass('is-hover');
					resizeImg($this);
				}, 600);
			}).mouseleave(function() {
				let $this = $(this);
				$this.removeClass('is-hover');
				clearInterval(this.mouseTimer);
			});

			$('.d-level-2 > li').hover(function() {
				let $this = $(this);
				$('.d-level-2 > li').removeClass('active');
				$this.addClass('active');
				// assign class expand to back to main side level 1
				let $linkLevel1 = $this.closest('.has-3-level').find('> a');
				if (!$linkLevel1.hasClass('expand')) $linkLevel1.addClass('expand');
				let $containerLeftNav = $this.closest('.d-level-2-outline');
				let paddingLeftSide = 50;
				let leftSide = $containerLeftNav.find('.d-level-2-outline-top').outerHeight() + $containerLeftNav.find('.d-level-2-outline-bottom').outerHeight() + paddingLeftSide;
				// container megamenu level 3
				let wrapperLevel2 = $this.closest('.desktop-megaMenu-wrapper');
				// container level 4 absolute
				let wrapperLevel3 = $this.find('.megaMenu-main-side');
				// clear height for left/ right side
				$(wrapperLevel3).css('height', '');
				$(wrapperLevel2).css('height', '');
				let level3Height = wrapperLevel3.outerHeight();
				let mainSideBottom = wrapperLevel2.find('.main-side-bottom');
				const rightBottomBar = mainSideBottom[0] ? $(mainSideBottom[0]).height() : 0;
				// min height for mega menu is 380px included bottom link
				let minHeightMega = 380;
				let rightSide = level3Height + rightBottomBar;
				let rightPanelHeight = 0;
				if ( rightSide > leftSide) {
					rightPanelHeight = rightSide < minHeightMega ? minHeightMega : rightSide;
				} else {
					$(wrapperLevel3).css('height', leftSide < 300 ? 300 : leftSide);
					rightPanelHeight = leftSide < minHeightMega ? minHeightMega : leftSide;
				}
				$(wrapperLevel2).css('height', rightPanelHeight);
				resizeImg($this);
			});
			// Remove active class on level 2 when leave level 1
			$('li.has-3-level').mouseenter(function() {
				resizeImg($(this));
			});

			const clearStatusLevel2 = function(currentItem) {
				currentItem.find('.desktop-megaMenu-wrapper').css('height', '');
				currentItem.find('.megaMenu-main-side').css('height', '');
				currentItem.find('.d-level-2 > li').removeClass('active');
			};

			$('li.has-3-level').mouseleave(function() {
				$(this).find('a.expand').removeClass('expand');
				clearStatusLevel2($(this));
			});

			$('li.has-3-level > a').mouseover(function() {
				let $parent = $(this).parent();
				$(this).toggleClass('expand');
				if (!$(this).hasClass('expand')) {
					clearStatusLevel2($parent);
				}
			});

			$('.header-icon').on('click', function() {
				$('.header-action ul li').removeClass('active');
				const $li = $(this).closest('li');
				$li.addClass('active');
				if ($li.hasClass('header-item-cart')) {
					const $emailList = $('.cart-list .cart-item .email-split');
					if ($emailList.length) {
						$emailList.each(function(index, el) {
							splitEmailEgiftCard($(el), 28, 28);
						});
					}
				}
			});
			$('.header-expand .icon-close').on('click', function() {
				$(this).closest('li').removeClass('active');
			});
			// Handle click outside
			$(document).on('click', (event)=> {
				const $target = event.target;
				const $headerAction = $('.siteHeader .header-action');
				if (!$headerAction.has($target).length && !$headerAction.is($target)) {
					$headerAction.find('li').removeClass('active');
				}
			});
		}
	}

	onResize() {
		let $this = $(this.$el);
		let navLinks = $this.find(BLK + 'navLinks');
		let $searchWrapper = $this.find(BLK + 'searchMobile');
		$(window).resize(()=> {
			if (!utils.isOnMobile()) {
				$searchWrapper.removeClass('hide');
				// this.toggleSiteNavItemsOnHover();

				// $this.find('.navbar-toggler[aria-expanded="true"]').trigger('click');
				$this.find('.accordion-group').removeAttr('style');
				// hide opened items and toggle the menu button
				// 	if (navLinks.hasClass('show')) {
				// 		$('.siteHeader').find('.navbar-toggler').trigger('click');
				// 	}

				// navItem.each(function() {
				// 	$(this).removeClass('show');
				// 	$(this).find('.dropdown-menu').removeClass('show');
				// 	$(this).find('.dropdown-toggle').attr('aria-expanded', 'false');
				// });
			} else {
				$this.find('.dropdown').removeClass('open');
				$this.find('.accordion-group').hide();
			}
		});
	}

	toggleSearch() {
		let $this = $(this.$el);
		let $searchWrapper = $this.find(BLK + 'searchMobile');
		let activeCategory = $this.find('.active-category');
		$this.on('click', '.navbar-toggler[aria-expanded="false"]', () => {
			$searchWrapper.addClass('hide');
			this.activateMenu(activeCategory, true);
		});
		$this.on('click', '.navbar-toggler[aria-expanded="true"]', () => {
			$searchWrapper.removeClass('hide');
			this.activateMenu(activeCategory, false);
		});
	}

	activateMenu(activeCategory, isOpen) {
		if (isOpen) {
			$(activeCategory).parent().css('display', 'block');
			$(activeCategory).parent().closest('.dropdown-menu').css('display', 'block');
			$(activeCategory).parent().closest('.dropdown').addClass('open');
		} else {
			$('.dropdown-menu, .accordion-group').css('display', 'none');
			$('.dropdown').removeClass('open');
		}
	}

	toggleSiteNavItemsOnHover() {
		const That = this;
		let $this = $(this.$el);
		let navItem = $this.find('.menuItem.has-sub');

		navItem.hover(
			function() {
				if (!utils.isOnMobile()) {
					// apply
					let $subContainer = $(this).find('.sub-container');
					$(this).addClass('open');
					$subContainer.addClass('active');
					//setTimeout(() => {
						That.calcSubmenuHeight($subContainer);
					//}, 300);
				}
			},
			function() {
				if (!utils.isOnMobile()) {
					// revert
					let $subContainer = $(this).find('.sub-container');
					let $colLeft = $subContainer.find('.megaMenuTab-colLeft');

					$(this).removeClass('open');
					$subContainer.removeClass('active');
					$($subContainer.find('.megaMenuTab-colLeft, .megaMenuTab-colRight')).attr('style', '');
					$colLeft.find('.megaMenuTab-nav-category').attr('style', '');
				}
			}
		);
	}

	menuMobileAccordion() {
		let That = this;
		let $this = $(this.$el);


		if (utils.isOnMobile()) {
			$this.find('.accordion-group').hide();
		}

		// comment this out as I can't find any dropdown-toggle element on the site-header,
		// and it cancel out the region selector widget
		// $this.on('click', '.dropdown-toggle', function(e) {
		// 	if (utils.isOnMobile()) {
		// 		That.accordion = $(this).parent().parent();
		// 		That.content = That.accordion.find('> .accordion-group');
		// 		That.toggleAccordion();
		// 	} else {
		// 		e.stopPropagation();
		// 	}
		// });
	}

	toggleAccordion() {
		let That = this;
		That.closeSiblingAccordions(That.accordion);
		if (That.accordion.hasClass('open')) {
			That.closeAccordion(That.accordion, That.content);
		} else {
			That.accordion.addClass('open');
			That.content.slideDown();
		}
	}

	closeAccordion($accordion, $content) {
		const That = this;
		$accordion.removeClass('open');
		$content.slideUp();
	}

	closeSiblingAccordions($accordion) {
		const That = this;
		let $siblings = $accordion.siblings('.dropdown').filter('.open');
		let	$siblingsChildren = $siblings.find('.dropdown').filter('.open');
		let $otherAccordions = $siblings.add($siblingsChildren);
		$otherAccordions.each(function() {
			let $accordion = $(this);
			let	$content = $accordion.find('.accordion-group');
			That.closeAccordion($accordion, $content);
		});
		$otherAccordions.removeClass('open');
	}

	setStickyHeader() {
		let $blk = $(this.$el);
		let mainPaddingOffset = parseFloat($blk.next('main').css('padding-top'));
		if ($blk.hasClass('is-sticky')) {
			let scrollHeight;
			$(window).on('scroll', function() {
				if (!utils.isOnMobile()) {
					scrollHeight = $blk.find(BLK + 'topLinks').height();
				} else {
					scrollHeight = 0;
				}
				if ($(window).scrollTop() >= scrollHeight) {
					$blk.addClass('sticky');
					$blk.next('main').css({
						'padding-top': $blk.height() + mainPaddingOffset,
					});
				} else {
					$blk.removeClass('sticky');
					$blk.next('main').css({
						'padding-top': '',
					});
				}
			});
			$(window).trigger('scroll');
		}
	}

	calcSubmenuHeight($subContainer) {
		const $this = $(this.$el);
		let winH = window.innerHeight;
		let siteHeaderH = $this.height();
		let subContH = $subContainer.height();
		//console.log(`winH: ${winH}, siteHeaderH: ${siteHeaderH}, subContH: ${subContH}`);

		// add custom height
		if (winH < (siteHeaderH + subContH)) {
			let $colLeft = $subContainer.find('.megaMenuTab-colLeft');
			let $colRight = $subContainer.find('.megaMenuTab-colRight');

			var newH = winH - siteHeaderH - 16;
			$colLeft.css('max-height', `${newH}px`);
			$colLeft.find('.megaMenuTab-nav-category').css('overflow-y', 'auto');
			$colRight.css({
				maxHeight: `${newH}px`,
				overflowY: 'auto'
			});
		}
	}

	handleLogoutCDC() {
		const $headerLogout = $('.header-logout');
		if (window.gigya && $headerLogout.length) {
			$headerLogout.click(function(event) {
				const href = $(this).attr('href');
				event.preventDefault();
				window.gigya.accounts.logout({
					callback() {
						window.location.href = href;
					},
				});
			});
		}
	}


	// Add more functions like on above here
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/blocks/siteHeader/js/siteHeader.js